import { useQuery } from "react-query";
import { USE_QUERY_OPTIONS } from "../../dynamicForm/lib/constants";
import { useAxiosInstance } from "../../dynamicForm/hooks/useAxiosInstance";

export const usePendingWellRegistrations = (enabled = true) => {
  const axiosInstance = useAxiosInstance();

  return useQuery(
    ["pending-well-registration"],
    async () => {
      const { data } = await axiosInstance.get(`/pending-well-registration`);
      return data;
    },
    {
      ...USE_QUERY_OPTIONS,
      enabled,
    }
  );
};
